import StaffAPI from '../../api/staff/StaffAPI';
import { FORM_OF_ACCOUNTING_KSIEGI_HANDLOWE } from '../constants/crm';
import modelId from '../procedures/model-id';
import store from '../store/store';

export default async function (to, from, next) {
  const activeBossCompanyFormOfAccounting = store.getters['auth/getActiveBossCompanyFormOfAccounting'];

  if (!activeBossCompanyFormOfAccounting) {
    next({ name: 'zus-warning-no-form-of-accounting' });
  }

  if (activeBossCompanyFormOfAccounting && FORM_OF_ACCOUNTING_KSIEGI_HANDLOWE === modelId(activeBossCompanyFormOfAccounting)) {
    try {
      const { data: countOfEmployees } = await StaffAPI.countOfEmployees();
      if (countOfEmployees <= 0) {
        next({ name: 'zus-warning-kh-no-employees' });
      }
    } catch (error) {
      console.error('fetching employees count error', { error });
      next({ name: 'zus-warning-kh-no-employees' });
    }
  }

  next();
}
